module.exports = __webpack_public_path__ + "static/media/2-check.dcbbb270.svg";